import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatTooltipModule} from '@angular/material/tooltip';
import {UiComponentsModule} from '../../../../shared/shared-module-ui/ui-components.module';
import {SharedIconsModule} from '../../../../shared-modules/shared-icons/shared-icons.module';
import {AddStockItemComponent} from './add-stock-item.component';

/**
 * Standalone module for Add Stock Item so the modal can be opened from features
 * that do not load StockManagerModule (e.g. notifications retry flow).
 */
@NgModule({
  declarations: [AddStockItemComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatTooltipModule,
    UiComponentsModule,
    SharedIconsModule,
  ],
  exports: [AddStockItemComponent],
})
export class AddStockItemModule {}
